import React from "react";
import { statusColor } from "@/utils/format";
import { useLang } from "@/context/LanguageContext";

const statusKeyMap = {
  pending: "status_pending",
  processing: "status_processing",
  delivered: "status_delivered",
  canceled: "status_canceled",
  approved: "status_processing",
  rejected: "status_canceled",
  paid: "status_delivered",
};

export default function StatusBadge({ status, testId }) {
  const { t } = useLang();
  const label = t(statusKeyMap[status] || status) || status;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${statusColor(status)}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
